// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { SectionComponent, Button } from "@components";
import {
  EmailNotificationMainView,
  EmailNotificationContent as EmailNotificationContentView,
  EmailNotificationDefaultInstructions,
  EmailNotificationReasonSpecificInstructions as EmailNotificationReasonSpecificInstructionsView,
  EmailNotificationDistributionRulesView,
  HierarchyScope,
} from "@modules/service/components";
import type { HierarchyAssignment } from "@modules/service/types";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import type { EmailNotification } from "@modules/service/reducer/email-notifications/types";

type OwnProps = $Exact<{
  data: ?EmailNotification,
  schema: ?Object,
  hierarchy: ?HierarchyTree,
  assignments: Array<HierarchyAssignment>,
  onShowEdit: Function,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class EmailNotificationDetails extends React.Component<Props> {
  get locked() {
    return false;
  }

  get isDisabled() {
    return this.locked || (this.props.data || {}).isDefault;
  }

  handleShowEdit = (step: number) => () => {
    this.props.onShowEdit(this.props.data, step);
  };

  render() {
    if (!this.props.data) {
      return null;
    }

    return (
      <React.Fragment>
        <SectionComponent
          wrapperClassName="flex-column mb-4"
          title={<h5>{this.props.t("EMAIL_NOTIFICATION_STEP1")}</h5>}
          rightLink={
            <Button materialIcon="edit" onClick={this.handleShowEdit(1)} disabled={this.isDisabled}>
              {this.props.t("EDIT")}
            </Button>
          }
        >
          <EmailNotificationMainView data={this.props.data} />
          {this.props.data && (
            <EmailNotificationContentView data={this.props.data} schema={this.props.schema} />
          )}
          <EmailNotificationDefaultInstructions data={this.props.data} schema={this.props.schema} />
        </SectionComponent>
        <SectionComponent
          wrapperClassName="flex-column mb-4"
          title={<h5>{this.props.t("EMAIL_NOTIFICATION_STEP2")}</h5>}
          rightLink={
            <Button materialIcon="edit" onClick={this.handleShowEdit(2)} disabled={this.isDisabled}>
              {this.props.t("EDIT")}
            </Button>
          }
        >
          <EmailNotificationReasonSpecificInstructionsView
            data={this.props.data}
            schema={this.props.schema}
          />
        </SectionComponent>
        <SectionComponent
          wrapperClassName="flex-column mb-4"
          title={<h5>{this.props.t("EMAIL_NOTIFICATION_STEP3")}</h5>}
          rightLink={
            <Button materialIcon="edit" onClick={this.handleShowEdit(3)} disabled={this.isDisabled}>
              {this.props.t("EDIT")}
            </Button>
          }
        >
          <EmailNotificationDistributionRulesView data={this.props.data} />
        </SectionComponent>
        <SectionComponent
          wrapperClassName="flex-column mb-4"
          title={<h5>{this.props.t("EMAIL_NOTIFICATION_STEP4")}</h5>}
          rightLink={
            <Button materialIcon="edit" onClick={this.handleShowEdit(4)} disabled={this.isDisabled}>
              {this.props.t("EDIT")}
            </Button>
          }
        >
          {this.props.assignments.length ? (
            <HierarchyScope hierarchy={this.props.hierarchy} assignments={this.props.assignments} />
          ) : (
            <div className="my-5 d-flex justify-content-center">
              <h3 className="text-pinkish-grey">
                {this.props.t("EMAIL_NOTIFICATIONS_SECTION_EMPTY")}
              </h3>
            </div>
          )}
        </SectionComponent>
      </React.Fragment>
    );
  }
}

export default localize()(EmailNotificationDetails);
